module.exports = __webpack_public_path__ + "img/rear_R.2c49429c.svg";